<template>
  <div>
    <div class="flex flex-between item-center bg mb10 p20 ">
      <div class="flex item-center">
        <el-button
            type="primary"
            size="small"
            @click="wantTo('cz', '账户充值')"
            class="mr10"
        >我要充值</el-button
        >账户余额：
        <span class="primary" style="font-size: 20px; margin-right: 15px;"
        >¥{{ accountBalanceMoney }}</span
        >
        <el-button
                size="small"
                @click="withdrawDeposit = true"
                style=""
                class="oo"
        >提现申请</el-button>
      </div>
      <div v-if="isRedpackageSupplier">
        当前供货商:<span class="primary">{{ storeName }}</span>
      </div>
    </div>

    <el-dialog title="提现申请" :visible.sync="withdrawDeposit" width="30%">
      <el-form>
        <el-form-item label="支付宝账户：">
          <el-input size="small" disabled v-model="account"></el-input>
          <p style="line-height: 20px; color: #666666">增加或更改账户请联系运营人员</p>
        </el-form-item>
        <el-form-item label="提现金额：">
          <el-input size="small" placeholder="请输入提现金额" v-model="cash_withdrawal_amount" @blur="verify" ref="amount"></el-input>
          <p style="line-height: 20px; color: red;">最低提现门槛100元</p>
        </el-form-item>
      </el-form>
      <div class="flex flex-center">
        <el-button size="small" type="primary" @click="commit">确认</el-button>
        <el-button @click="withdrawDeposit=false"  size="small">取消</el-button>
      </div>
    </el-dialog>

    <hm-content title="">
      <div class="mb10">
        <el-button
          size="small"
          @click="wantTo('buy', '我要购买')"
          style=""
          class="oo"
          >我要购买</el-button
        >
        <!-- <el-button type="primary" size="small" class="mr10" @click="ggg"
          >账户充值流水</el-button
        > -->
      </div>
      <div>
        <el-table
          :data="list"
          style="width: 100%"
          ref="table"
          stripe
          border
          size="small"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="流水类型"
            prop="templateCode"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.billType === 'recharge'">
                <div v-if="scope.row.rechargeMode === 'online'">线上充值</div>
                <div v-else>线下充值</div>
              </div>
              <div v-else>
                <div v-if="scope.row.billType === 'buyServiceProject_share'">
                  代发分销佣金充值
                </div>
                <div v-else-if="scope.row.billType === 'buyServiceProject_sms'">
                  短信条数扣费
                </div>
                <div v-else-if="scope.row.billType === 'buyServiceProject_rdPack'">
                  红包申报扣费
                </div>
                <div
                  v-else-if="scope.row.billType === 'buyServiceProject_idCard'"
                >
                  身份认证数扣费
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="充值单号"
            prop="billSn"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="充值时间"
            prop="tradeTime"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="金额"
            prop="tradeMoney"
          >
            <template slot-scope="scope">
              <div class="success">¥{{ scope.row.tradeMoney }}</div>
            </template>
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              label="购买值"
              v-if="isRedpackageSupplier"
              prop="serviceInitValue"
          >
            <template slot-scope="scope">
              <div class="success">{{ scope.row.serviceInitValue }}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
    </hm-content>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      width="1000px"
      :visible.sync="dialogVisible"
    >
      <template v-if="type === 'buy' && !isRedpackageSupplier">
        <div class="flex flex-between">
          <div
            v-for="(v, i) in buyTypeList"
            :key="i"
            class="item pointer"
            @click="actived(v, i)"
            :class="{ active: i === active }"
          >
            <div class="text-center">
              <el-image
                style="width: 100px; height: 100px"
                :src="v.url"
              ></el-image>
            </div>
            <div class="text-center mt10 name">
              {{ v.name }}
            </div>
            <div class="text-center gray mt10" style="line-height: 20px">
              {{ v.content }}
            </div>

            <div class="replace-item" v-if="i === active">
              <div class="jiao"></div>
              <div class="desc">
                <i class="el-icon-check"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="mt20">
          <div class="mb10">
            <span class="fw7">充值选项</span>

            <span
              >（当前帐户余额
              <span class="primary"> {{ accountBalanceMoney }}</span
              >元）</span
            >
          </div>
          <div v-if="active === 0">
            <el-form
              class="priceBt"
              ref="ruleForm"
              :model="ruleForm"
              :rules="rules"
              label-width="100px"
            >
              <el-form-item label="充值面额">
                <el-radio-group v-model="ruleForm.price">
                  <el-radio
                    border
                    class="mr10"
                    :label="v.itemValue"
                    v-for="(v, i) in rechareList"
                    :key="i"
                    >{{ v.itemText }}元</el-radio
                  >
                </el-radio-group>
                <!-- <el-button type="primary" plain size="small">5000</el-button> -->
              </el-form-item>
              <el-form-item label="充值金额" prop="price">
                <el-input
                  clearable
                  v-model.trim="ruleForm.price"
                  size="small"
                  placeholder="请输入充值金额"
                ></el-input>
              </el-form-item>
              <el-form-item label="余额预警" required>
                <div class="flex">
                  当余额低于
                  <el-form-item prop="warningValue">
                    <el-input
                      clearable
                      v-model.trim="ruleForm.warningValue"
                      size="small"
                      placeholder="请输入预警金额"
                    ></el-input>
                  </el-form-item>
                  元时，发送短信至
                  <el-form-item prop="warningPhone">
                    <el-input
                      clearable
                      v-model.trim="ruleForm.warningPhone"
                      size="small"
                      placeholder="请输入手机号"
                    ></el-input>
                  </el-form-item>
                  预警提示
                </div>
              </el-form-item>
            </el-form>
          </div>
          <template v-else>
            <div class="flex mb20">
              <div
                v-for="(v, i) in rechareList"
                :key="i"
                class="pointer rechare-item mr10"
                @click="activeRechare(v, i)"
                :class="{ active: i === rechareActive }"
              >
                <div class="text-center p10">
                  <span style="font-size: 22px">{{ v.price }}</span>
                  <span style="font-size: 16px"
                    >/{{ v.number }}{{ active === 1 ? "条" : "次" }}</span
                  >
                </div>
                <div class="text-center adwdss">
                  低至{{ v.cao }}元/{{ active === 1 ? "条" : "次" }}
                </div>
                <div class="replace-item" v-if="i === rechareActive">
                  <div class="jiao"></div>
                  <div class="desc">
                    <i class="el-icon-check"></i>
                  </div>
                </div>
              </div>
            </div>
            <el-form
              class="priceBt"
              ref="ruleForm"
              inline
              :model="ruleForm"
              :rules="rules"
              label-width="80px"
            >
              <el-form-item label="余额预警" required>
                <div class="flex">
                  当余额低于
                  <el-form-item prop="warningValue">
                    <el-input
                      clearable
                      v-model.trim="ruleForm.warningValue"
                      size="small"
                      placeholder="请输入预警金额"
                    ></el-input>
                  </el-form-item>
                  元时，发送短信至
                  <el-form-item prop="warningPhone">
                    <el-input
                      clearable
                      v-model.trim="ruleForm.warningPhone"
                      size="small"
                      placeholder="请输入手机号"
                    ></el-input>
                  </el-form-item>
                  预警提示
                </div>
              </el-form-item>
            </el-form>
          </template>
        </div>
        <!-- <div class="mt10 mb20">
          <span class="fw7">价格：</span> 98元
          <span class="gray"
            >原价：
            <span style="text-decoration:line-through;">100元</span></span
          >
        </div> -->

        <div style="margin-top: 30px; line-height: 22px" v-if="active === 1">
          <div>
            温馨提示：
            <span class="primary">短信包不支持退款，请确认后购买</span>
          </div>
          <div class="gray">
            1.短信内容不允许涉及政治、色情、暴力、赌博以及其他违法信息
          </div>
          <div class="gray">
            2.短信属于公众服务，受国家政策法规限制,具体审核结果以短信平台审核结果为准
          </div>
          <div class="gray">
            3.股票、游戏、出国、医疗器械、代理、珠宝、保健品、茶叶、KTV、养生足浴SPA、皮草、A货、奢侈品、金融、教育、房产、兼职招聘、装修装饰、资质代办、培训、会议邀约、买卖手机、以旧换新、流量话费类等涉及以上行业内容营销短信不支持发送
          </div>
        </div>
      </template>
      <template v-else-if="type === 'buy' && isRedpackageSupplier">
        <div class="flex flex-between">
          <div
              v-for="(v, i) in buyRedpackageSupplierTypeList"
              :key="i"
              class="item pointer"
              @click="actived(v, i)"
              :class="{ active: i === active }"
          >
            <div class="text-center">
              <el-image
                  style="width: 100px; height: 100px"
                  :src="v.url"
              ></el-image>
            </div>
            <div class="text-center mt10 name">
              {{ v.name }}
            </div>
            <div class="text-center gray mt10" style="line-height: 20px">
              {{ v.content }}
            </div>

            <div class="replace-item" v-if="i === active">
              <div class="jiao"></div>
              <div class="desc">
                <i class="el-icon-check"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="mt20">
          <div class="mb10">
            <span class="fw7">充值选项</span>

            <span
            >（当前帐户余额
              <span class="primary"> {{ accountBalanceMoney }}</span
              >元）</span
            >
          </div>
          <template>
            <div class="flex mb20">
              <div
                  v-for="(v, i) in rechareList"
                  :key="i"
                  class="pointer rechare-item mr10"
                  @click="activeRechare(v, i)"
                  :class="{ active: i === rechareActive }"
              >
                <div class="flex" v-if="v.priority == 'true'">
                  <div class="youxian">优先扣</div>
                </div>
                <div class="text-center mt20 yxq">有效期{{ v.validityDate }}天</div>
                <div class="text-center p10">
                  <span style="font-size: 22px">{{ v.price }}元</span>
                  <span style="font-size: 16px"
                  >/{{ v.number }}次</span
                  >
                </div>
                <div class="text-center adwdss">
                  低至{{ v.cao }}元/{{ active === 1 ? "条" : "次" }}
                </div>
                <div class="replace-item" v-if="i === rechareActive">
                  <div class="jiao"></div>
                  <div class="desc">
                    <i class="el-icon-check"></i>
                  </div>
                </div>
              </div>
            </div>
            <el-form
                class="priceBt"
                ref="ruleForm"
                inline
                :model="ruleForm"
                label-width="80px"
            >
              <el-form-item label="余额预警">
                <div class="flex">
                  当余量低于
                  <el-form-item prop="warningValue">
                    <el-input
                        clearable
                        v-model.trim="ruleForm.warningValue"
                        size="small"
                        placeholder="请输入预警余量"
                    ></el-input>
                  </el-form-item>
                  时，发送短信至
                  <el-form-item prop="warningPhone">
                    <el-input
                        clearable
                        v-model.trim="ruleForm.warningPhone"
                        size="small"
                        placeholder="请输入手机号"
                    ></el-input>
                  </el-form-item>
                  预警提示
                </div>
              </el-form-item>
            </el-form>
          </template>
        </div>
      </template>

      <el-form
        v-else
        class="priceBt"
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="充值面额">
          <el-radio-group v-model="ruleForm.price">
            <el-radio
              border
              class="mr10"
              :label="v.val"
              v-for="(v, i) in priceList"
              :key="i"
              >{{ v.label }}</el-radio
            >
          </el-radio-group>
          <!-- <el-button type="primary" plain size="small">5000</el-button> -->
        </el-form-item>
        <el-form-item label="充值金额" prop="price">
          <el-input
            clearable
            v-model.trim="ruleForm.price"
            size="small"
            placeholder="请输入充值金额"
          ></el-input>
          <!-- （当前帐户余额<span class="primary">{{ accountBalanceMoney }}</span
          >元） -->
        </el-form-item>
        <!-- <el-form-item label="余额预警" required>
          <div class="flex">
            当余额低于
            <el-form-item prop="warningValue">
              <el-input
                clearable
                v-model.trim="ruleForm.warningValue"
                size="small"
                placeholder="请输入预警金额"
              ></el-input>
            </el-form-item>
            元时，发送短信至
            <el-form-item prop="warningPhone">
              <el-input
                clearable
                v-model.trim="ruleForm.warningPhone"
                size="small"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
            预警提示
          </div>
        </el-form-item> -->
      </el-form>
      <div class="btn-wrapper flex flex-center" slot="footer">
        <el-button size="small" type="primary" @click="confirm('ruleForm')"
          >确 定</el-button
        >
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </div>
      <el-dialog
        width="30%"
        title="付款码"
        :visible.sync="innerVisible"
        append-to-body
      >
        <div class="form-tip">请使用微信或支付宝扫码支付</div>
        <div class="text-center">
          <img class="paycode" :src="payCodeUrl" alt="付款码" />
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcode";
export default {
  data() {
    const priceFunc = (rule, val, callback) => {
      let limitPrice =
        this.type === "cz"
          ? this.priceList[0].val
          : this.shareRechargeList[this.active].itemValue;
      if (val < limitPrice) {
        return callback(new Error(`充值金额不得小于${limitPrice}元`));
      }
      callback();
    };
    return {
      cash_withdrawal_amount:'',   //提现金额
      account:0,
      withdrawDeposit:false,
      rechareList: [],
      active: 0,
      rechareActive: 0,
      buyTypeList: [
        {
          url: "https://imgcdn.hemiao100.com/ThemePictures/0210901172001.png",
          name: "常规金额扣费项目充值",
          content: "用于佣金、达达配送等场景，根据订单收取",
          buyType: "shareRechargeList",
          accountType: "share"
        },
        {
          url: "https://imgcdn.hemiao100.com/ThemePictures/_20210901172053.png",
          name: "短信条数扣费项目充值",
          content: "购买短信条数，购买后按条数扣除",
          buyType: "smsRechargeList",
          accountType: "sms"
        },
        {
          url: "https://imgcdn.hemiao100.com/ThemePictures/_20210901172057.png",
          name: "身份认证次数扣费项目充值",
          content: "购买身份认证次数，购买后按次数扣除",
          buyType: "IdCardRechargeList",
          accountType: "idCard"
        }
      ],
      buyRedpackageSupplierTypeList: [
        {
          url: "https://imgcdn.hemiao100.com/ThemePictures/shenhetaocanchongzhi.png",
          name: "红包审核套餐充值",
          content: "用于红包申报时抵扣审单手续费",
          buyType: "redPackagePackRechargeList",
          accountType: "rdPack"
        }
      ],
      title: "",
      type: "",
      innerVisible: false,
      payCodeUrl: "",
      socket: "",
      accountBalanceMoney: 0,
      dialogVisible: false,
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      ruleForm: {
        price: "",
        warningValue: "",
        warningPhone: ""
      },
      rules: {
        price: [
          {
            required: true,
            message: "请输入充值金额",
            trigger: "blur"
          },
          {
            validator(rule, value, callback) {
              if (Number.isInteger(Number(value)) && Number(value) > 0) {
                callback();
              } else {
                callback(new Error("请输入大于0的正整数"));
              }
            },
            trigger: "blur"
          },
          { required: true, validator: priceFunc, trigger: "blur" }
        ],
        warningValue: [
          {
            required: true,
            validator(rule, value, callback) {
              if (Number.isInteger(Number(value)) && Number(value) > 0) {
                callback();
              } else {
                callback(new Error("请输入大于0的正整数"));
              }
            }
          }
        ],
        warningPhone: {
          required: true,
          pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
          message: "请正确填写你的手机号",
          trigger: "blur"
        }
      },
      priceList: [
        {
          label: "5000元",
          val: 5000
        },
        {
          label: "10000元",
          val: 10000
        },
        {
          label: "15000元",
          val: 15000
        },
        {
          label: "20000元",
          val: 20000
        },
        {
          label: "25000元",
          val: 25000
        },
        {
          label: "30000元",
          val: 30000
        },
        {
          label: "50000元",
          val: 50000
        }
      ],
      shareRechargeList: [],
      smsRechargeList: [],
      IdCardRechargeList: [],
      storeName: "",
      isRedpackageSupplier: false,
      redPackagePackRechargeList: []
    };
  },
  created() {},
  mounted() {
    if (this.$route.query.storeCode) {
      this.isRedpackageSupplier = true;
      this.storeName = localStorage.getItem("storeName");
    }
    this.queryBalance();
    this.queryDictItemsCode();
    this.alipayAccount();
  },
  methods: {
    async commit(){
      await this.$store.dispatch("cash_out_apply",{
        getcashMoney:this.cash_withdrawal_amount
      });
      this.$message({
        message: "提现成功！",
        type: "success"
      });
      this.withdrawDeposit = false;
    },
    verify(){   //金额验证
      if(this.cash_withdrawal_amount < 100 || this.cash_withdrawal_amount == ''){
        this.$message({
          message: "提现金额必须大于100！",
          type: "warning"
        });
        this.$refs.amount.focus();
      }
    },
    //支付宝账户查询A
    async alipayAccount(){
      const { result } = await this.$store.dispatch("storeBasicInfo_info");
      console.log(result);
      this.account = result.alipayAccount
    },
    //查询预警信息
    async queryAccountWaringInfo() {
      let params = {};
      if (this.isRedpackageSupplier) {
        params.accountType = this.buyRedpackageSupplierTypeList[this.active].accountType;
        params.queryDataStoreType = "redpackageSupplier";
        params.storeCode = this.$route.query.storeCode;
      } else {
        params.accountType = this.buyTypeList[this.active].accountType;
      }
      const { result } = await this.$store.dispatch("queryAccountWaringInfo", params);
      const { warningValue, warningPhone } = result;
      this.ruleForm.warningValue = warningValue;
      this.ruleForm.warningPhone = warningPhone;
    },
    ggg() {
      this.$router.push({
        name: "RechargeDetails"
      });
    },
    selectRecharge() {
      if (this.isRedpackageSupplier) {
        this.rechareList = this[this.buyRedpackageSupplierTypeList[this.active].buyType];
      } else {
        this.rechareList = this[this.buyTypeList[this.active].buyType];
      }
    },
    async queryDictItemsCode() {
      if (this.isRedpackageSupplier) {
        let redPackagePackRechargeList = await this.$store.dispatch("queryDictItemsCode", {
          dictCode: "rdPackRecharge"
        });
        redPackagePackRechargeList.result.forEach(v => {
          let list = v.itemValue.split(";");
          v.price = list[0];
          v.number = list[1];
          v.cao = list[2];
          v.validityDate = list[3];
          v.priority = list[4];
        });
        this.redPackagePackRechargeList = redPackagePackRechargeList.result;
      } else {
        let shareRecharge = await this.$store.dispatch("queryDictItemsCode", {
          dictCode: "shareRecharge"
        });
        this.shareRechargeList = shareRecharge.result;

        let smsRecharge = await this.$store.dispatch("queryDictItemsCode", {
          dictCode: "smsRecharge"
        });
        smsRecharge.result.forEach(v => {
          let list = v.itemValue.split(";");
          v.price = list[0];
          v.number = list[1];
          v.cao = list[2];
        });
        this.smsRechargeList = smsRecharge.result;

        let IdCardRecharge = await this.$store.dispatch("queryDictItemsCode", {
          dictCode: "IdCardRecharge"
        });
        IdCardRecharge.result.forEach(v => {
          let list = v.itemValue.split(";");
          v.price = list[0];
          v.number = list[1];
          v.cao = list[2];
        });
        this.IdCardRechargeList = IdCardRecharge.result;
      }
      this.selectRecharge();
    },
    actived(row, i) {
      if (this.active === i) {
        return;
      }
      this.active = i;
      this.selectRecharge();
      this.queryAccountWaringInfo();
      this.rechareActive = 0;
    },
    activeRechare(row, i) {
      this.rechareActive = i;
    },
    async confirm(formName) {
      if (this.type === "cz") {
        const valid = await this.$refs[formName].validate();
        if (valid) {
          const { result } = await this.$store.dispatch("toRecharge", {
            rechargeMoney: this.ruleForm.price
          });
          QRCode.toDataURL(result.message.qr_url)
            .then(payCodeUrl => {
              this.payCodeUrl = payCodeUrl;
              this.innerVisible = true;
              this.terminal_trace = result.message.terminal_trace;
              this.init();
            })
            .catch(err => {
              throw new Error(err);
            });
        }
      } else {
        let params = {};

        const valid = await this.$refs[formName].validate();
        if (valid) {
          if (this.isRedpackageSupplier) {
            params = {
              accountType: this.buyRedpackageSupplierTypeList[this.active].accountType,
              warningValue: this.ruleForm.warningValue,
              warningPhone: this.ruleForm.warningPhone
            };

            let item = this.rechareList[this.rechareActive];

            params.accountBalanceMoney = item.price;
            params.accountBalanceNum = item.number;
            params.validityDate = item.validityDate;
            params.priorityFlag = "true" == item.priority ? "1" : "0";
            params.queryDataStoreType = "redpackageSupplier";
            params.storeCode = this.$route.query.storeCode;
          } else {
            params = {
              accountType: this.buyTypeList[this.active].accountType,
              warningValue: this.ruleForm.warningValue,
              warningPhone: this.ruleForm.warningPhone
            };

            if (this.active === 0) {
              params.accountBalanceMoney = this.ruleForm.price;
            } else {
              let item = this.rechareList[this.rechareActive];

              params.accountBalanceMoney = item.price;
              params.accountBalanceNum = item.number;
            }
          }


          await this.$store.dispatch("buyServiceProject", params);
          this.dialogVisible = false;
          this.$message({
            message: "操作成功！",
            type: "success"
          });
          // QRCode.toDataURL(result.message.qr_url)
          //   .then(payCodeUrl => {
          //     this.payCodeUrl = payCodeUrl;
          //     this.innerVisible = true;
          //     this.terminal_trace = result.message.terminal_trace;
          //     this.init();
          //   })
          //   .catch(err => {
          //     throw new Error(err);
          //   });
        }
      }
      this.queryBalance();
    },
    async queryBalance() {
      let url = "";
      let params = {};
      if (this.isRedpackageSupplier) {
        url = "queryBalanceByStoreCode";
        params.storeCode = this.$route.query.storeCode;
      } else {
        url = "queryBalance";
      }
      const { result } = await this.$store.dispatch(url, params);
      this.accountBalanceMoney = result.accountBalanceMoney;
      this.queryList();
    },
    wantTo(type, title) {
      this.type = type;
      this.title = title;
      this.active = 0;
      this.rechareActive = 0;
      this.ruleForm = {
        price: "",
        warningValue: "",
        warningPhone: ""
      };
      this.dialogVisible = true;
      this.queryAccountWaringInfo();
    },
    init() {
      if (typeof WebSocket === "undefined") {
        alert("您的浏览器不支持socket");
      } else {
        // 实例化socket
        this.socket = new WebSocket(this.$wsAddress);
        // 监听socket连接
        this.socket.onopen = this.open;
        // 监听socket错误信息
        this.socket.onerror = this.error;
        // 监听socket消息
        this.socket.onmessage = this.getMessage;
      }
    },
    open() {},
    error() {},
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      if (this.isRedpackageSupplier) {
        params.storeCode = this.$route.query.storeCode;
        params.queryDataStoreType = "redpackageSupplier";
      }
      const { code, result } = await this.$store.dispatch(
        "queryRechargeList",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss">
.bg {
  background-color: #ffffff;
}
.item {
  border-radius: 6px;
  border: 1px solid #dddddd;
  padding: 40px 17px 38px 17px;
  width: 233px;
  position: relative;
  overflow: hidden;
  &:hover {
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
  }
  &.active {
    border: 1px solid #e50065;
  }
  .name {
    font-weight: 600;
    color: #222222;
    font-size: 16px;
  }
  .replace-item {
    position: absolute;
    right: 0;
    bottom: 0;
    color: #ffffff;
    font-size: 12px;
  }
  .jiao,
  .desc {
    position: absolute;
    top: 0;
    right: 0;
  }
  .jiao {
    width: 30px;
    height: 30px;
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
    -moz-transform: rotate(135deg);
    -ms-transform: rotate(135deg);
    top: -16px;
    right: -14px;
    background-color: #e50065;
    padding: 0;
  }
  .desc {
    top: -12px;
  }
}

.rechare-item {
  border-radius: 6px;
  border: 1px solid #dddddd;
  width: 178px;
  position: relative;
  overflow: hidden;
  &.active {
    border: 1px solid #e50065;
    .adwdss {
      background: #fedeec;
    }
  }
  .adwdss {
    background: #f4f4f4;
    border-radius: 0px 0px 6px 6px;
    color: #e50065;
    padding: 6px 0;
    font-size: 14px;
  }
  .replace-item {
    position: absolute;
    right: 0;
    bottom: 0;
    color: #ffffff;
    font-size: 12px;
  }
  .jiao,
  .desc {
    position: absolute;
    top: 0;
    right: 0;
  }
  .jiao {
    width: 26px;
    height: 26px;
    transform: rotate(133deg);
    -webkit-transform: rotate(133deg);
    -moz-transform: rotate(133deg);
    -ms-transform: rotate(133deg);
    top: -14px;
    right: -13px;
    background-color: #e50065;
    padding: 0;
  }
  .desc {
    top: -12px;
  }
  .yxq {
    font-size: 14px;
    color: #999999;
  }
  .youxian {
    padding: 2px 6px;
    background-color: #E50065;
    border-radius: 6px 0px 6px 0px;
    color: #ffffff;
    font-size: 14px;
    position: absolute;
    left: 0;
    top: 0;
  }
}

.fw7 {
  font-weight: 700;
}
.oo {
  background: #0081e5;
  color: #fff;
  &:hover {
    border: 1px solid #0081e5;
  }
}
</style>
